import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AssessmentAnswerInterface, AssessmentQuestionInterface } from 'app/assessment/models';

@Component({
  selector: 'cz-unknown-question-group',
  templateUrl: './unknown-question-group.component.html',
})
export class UnknownQuestionGroupComponent implements OnInit {
  @Input() public readonly type: string;
  @Input() public readonly question: AssessmentQuestionInterface;
  @Input() public readonly form: FormGroup;
  @Input() public readonly parentQuestion: AssessmentQuestionInterface;
  @Input() public readonly imagePath: string;
  public followUp: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this.showFollowUpQuestions();
  }

  private showFollowUpQuestions(): void {
    if (typeof this.question === 'undefined' || !this.question) { return; }

    const childQuestions: AssessmentQuestionInterface[] = this.question.childQuestions;

    for (const key in childQuestions) {
      if (!childQuestions.hasOwnProperty(key)) { continue; }
      const childQuestionAnswers: AssessmentAnswerInterface[] = childQuestions[key].answers;

      for (const cqaKey in childQuestionAnswers) {
        if (!childQuestionAnswers.hasOwnProperty(cqaKey)) { continue; }

        if (childQuestionAnswers[cqaKey].isSelected) {
          this.followUp = true;
          break;
        } else {
          this.followUp = false;
        }
      }
    }
  }
}
